<script context="module" lang="ts">
</script>

<script lang="ts">
  import CustomIcon from "../../components/CustomIcon.svelte";
  import classNames from "../../utils/classNames";
  export let showModal = false;
  export let title = "";
  export let onClose = closeDialog
  export let titleClasses = "";
  export let modalClasses = "";
  
  function closeDialog() {
    showModal = false;
  }
</script>

{#if showModal}
  <div
    class="fixed z-[101] inset-0 overflow-y-auto"
    aria-labelledby="modal-title"
    role="dialog"
    aria-modal="true"
  >
    <div
      class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
    >
      <div
        class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
        aria-hidden="true"
      />

      <span
        class="hidden sm:inline-block sm:align-middle sm:h-screen"
        aria-hidden="true">&#8203;</span
      >

      <div
       class={classNames("bg-white inline-block rounded-lg shadow-xl sm:align-middle sm:p-6 text-left transform",modalClasses)}
      >
        <div class="block">
          <!-- <div
            type="button"
            class="hover:text-gray-500 border-transparent cursor-pointer"
            on:click={closeDialog}
          >
            <span class="sr-only">Close</span>

            <CustomIcon width="18" height="18" name="close_dialog" />
          </div> -->
          <button
            on:click={onClose}
            class="absolute autocomplete-clear-button border-0 font-bold px-1.5 right-2"
          >

            <CustomIcon
              name="close_notification"
              width="20"
              color="black"
              height="20"
            />
          </button>
          <div class={classNames("align-middle inline-block", titleClasses)}>{title}</div>
          <slot />
        </div>
      </div>
    </div>
  </div>
{/if}
